module.exports = __webpack_public_path__ + "media/images/temp/callout-image-fe365f4a31d2a52431806dad76ccad3b.png";